<div *ngIf="!showActiveTestCreateResult">
  <!-- Details of failure -->
  <div *ngIf="requestFailed() && !isLoading()">
    <div class="label--bold label medium-margin">
      <p>{{failureMsg}}</p>
    </div>
    <div class="status-msg-container">
      <div class="status">
        <div class="logo"><img src="{{step.parent.output.datasourceType.iconSrc}}" /></div>
        <div class="icon">
          <mat-icon class="failure">highlight_off</mat-icon>
        </div>
      </div>
    </div>

    <div class="retry-container">
      Reason for failure
      <p>{{wizardCtrl.wizardService.errorMessage}}</p>
    </div>
  </div>

  <!-- Details of success -->
  <div *ngIf="!requestFailed() && !isLoading()">
    <div class="header-msg">
      <p>{{successMsg}}</p>
    </div>
    <div class="status-msg-container">
      <div class="status">
        <div class="logo"><img src="{{step.parent.output.datasourceType.iconSrc}}" /></div>
      </div>

      <div class="status-msg">
        <mat-icon class="success">check_circle_outline</mat-icon>
        <div>{{ step.parent.output.alias }}</div>
        <div class="success">{{successFlag}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="isLoading()" class="retry-container">
    <div class="label label--bold medium-margin">
      <p>Retrying</p>
    </div>
    <mat-spinner></mat-spinner>
    <div class="label medium-margin">One moment...</div>
  </div>
</div>

<!-- Agent code -->

<div *ngIf="showActiveTestCreateResult">
  <div *ngIf="isLoading() && !step.output.status" class="loader">
    <div class="loader-msg-header">
      <p>Trying to add {{step.parent.output.datasourceType.label}}</p>
    </div>
    <mat-spinner></mat-spinner>
    <p class="loader-msg">One moment...</p>
  </div>

  <!-- Details for job failure -->
  <div *ngIf="requestFailed() && !isLoading()">
    <div class="label--bold label medium-margin">
      <p>{{failureMsg}}</p>
    </div>
    <div class="status-msg-container">
      <div class="status">
        <div class="logo"><img src="{{step.parent.output.datasourceType.iconSrc}}" /></div>
        <div class="icon">
          <mat-icon class="failure">highlight_off</mat-icon>
        </div>
      </div>
    </div>

    <div class="retry-container">
      Reason for failure
      <p>{{wizardCtrl.wizardService.errorMessage}}</p>
    </div>
  </div>

  <!-- Details for job status -->
  <div [ngSwitch]="step.output.status">
    <div class="retry-container" *ngSwitchCase="'SUBMITTED'">
      <div class="label label--bold medium-margin">
        <p>Creating agent</p>
        <mat-spinner></mat-spinner>
        <span class="desc"
          >You can close this dialog. <br />We will notify you when your agent has been
          created.</span
        >
      </div>
    </div>

    <div class="retry-container" *ngSwitchCase="'ADDED'">
      <div class="label label--bold medium-margin">
        <h3>Agent claimed successfully</h3>
      </div>
    </div>

    <div class="retry-container" *ngSwitchCase="'BUILDING'">
      <div class="label label--bold medium-margin">
        <p>Creating agent</p>
        <mat-spinner></mat-spinner>
        <span class="desc"
          >You can close this dialog. <br />We will notify you when your agent has been
          created.</span
        >
      </div>
    </div>

    <div *ngSwitchCase="'FAILED'">
      <div class="label--bold label medium-margin">
        <p>Agent creation was unsuccessful.</p>
      </div>
      <div class="status-msg-container">
        <div class="status">
          <div class="logo"><img src="{{step.parent.output.datasourceType.iconSrc}}" /></div>
          <div class="icon">
            <mat-icon class="failure">highlight_off</mat-icon>
          </div>
        </div>
      </div>
      <div class="retry-container">
        Reason for failure
        <p>{{step.output.reason}}</p>
      </div>
    </div>
  </div>
</div>
